import { Navigate, useLocation } from 'react-router-dom';
import { PrivateRouteI } from 'src/models/router';
import { RoutePath } from 'src/router/routePath';
import { isLogged } from 'src/services/auth';

export const PrivateRoute = ({ children }: PrivateRouteI) => {
  return isLogged ? children : <Navigate to={RoutePath.LOGIN} replace />;
};
